import CompanySettingsTabs from "./CompanySettingsTabs";

export default function CompanySettingsLanding() {
  return (
    <div className="container-fluid">
      <h2>Company Settings</h2>
      <CompanySettingsTabs />
    </div>
  );
}
